module.exports = __webpack_public_path__ + "img/team_bg.9fc0f044.jpg";